import api from "@utils/api";

export const getPlaces = (id) => {
  let organizationId = id;
  if (!organizationId) {
    const organizationString = sessionStorage.getItem("organization");
    if (organizationString) {
      const organization = JSON.parse(organizationString);
      organizationId = organization.organizacion_id;
    }
  }

  if (organizationId) {
    return api.get(`/place/organizacion/${organizationId}`);
  }

  console.error("Organization ID not found for fetching places.");
  return Promise.reject(new Error("Organization ID not found."));
};
export const getPlaceById = (id) => api.get(`/place/${id}`);
export const createPlace = (place) => api.post("/place", place);
export const updatePlace = (id, place) => api.put(`/place/${id}`, place);
export const deletePlace = (id) => api.delete(`/place/${id}`);
